var _style, _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _circle2, _path8, _path9, _path0, _path1, _g, _g2, _path10;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaitingWristWatch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#243038}.st2{fill:#75848f}.st4{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137 34.5c0-6.2-5.5-8-5.5-8s5.5-1.5 5.5-7.7-5.5-7.9-5.5-7.9H19.2v50.6h53.4v2.1c0 4.2 2.6 7.7 6.3 9.1l25.6 13.8s6.5 1.5 9.9-4.8c1.9-3.4 1.3-6.4.4-8.4h16.7s5.5-1.5 5.5-7.7-5.5-8-5.5-8 5.5-1.5 5.5-7.7c0-5.6-4.5-7.5-5.4-7.8.9-.2 5.4-2 5.4-7.6z",
    fill: "#fddfbb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.1 87.7c-1.1 0-1.8-.2-1.8-.2l-.3-.1-25.5-13.8c-4.1-1.6-6.9-5.6-6.9-10v-1.1H18.2V9.9h113.6c2.2.7 6.2 3.4 6.2 8.9 0 4-2.2 6.5-4.2 7.7 2 1.4 4.2 3.9 4.2 7.9 0 4.2-2.4 6.5-4.2 7.7 1.8 1.2 4.2 3.6 4.2 7.8 0 4-2.2 6.5-4.2 7.7 2 1.4 4.2 3.9 4.2 7.9 0 5.5-4.1 8.1-6.3 8.7H116.1c.6 2.1.7 4.8-.9 7.9-2.5 4.9-6.7 5.6-9.1 5.6zm-1.3-2.1c.9.2 5.9.8 8.7-4.3 1.4-2.5 1.5-5 .4-7.6l-.6-1.4h18.1c.8-.3 4.7-1.8 4.7-6.7 0-5.3-4.7-7-4.9-7l-3.1-1 3.1-.9c.2-.1 4.8-1.4 4.8-6.7 0-4.9-3.9-6.6-4.7-6.9l-2.6-1 2.7-.9c.8-.3 4.7-1.8 4.7-6.7 0-5.4-4.8-7-4.9-7l-3.1-1 3.2-.9c.2-.1 4.8-1.4 4.8-6.7 0-4.9-3.9-6.6-4.7-6.9H20.2v48.6h53.4v3.1c0 3.6 2.3 6.9 5.7 8.2l.1.1 25.4 13.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.5 64.9H42.1c-1.1 0-2-.9-2-2V10.3c0-1.1.9-2 2-2h23.4c1.1 0 2 .9 2 2v52.6c0 1.1-.9 2-2 2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.5 65.9H42.1c-1.7 0-3-1.3-3-3V10.3c0-1.7 1.3-3 3-3h23.4c1.7 0 3 1.3 3 3v52.6c0 1.7-1.3 3-3 3zM42.1 9.3c-.6 0-1 .4-1 1v52.6c0 .6.4 1 1 1h23.4c.6 0 1-.4 1-1V10.3c0-.6-.4-1-1-1H42.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7 64.9H3.3c-1.1 0-2-.9-2-2V2.7c0-1.1.9-2 2-2h23.4c1.1 0 2 .9 2 2v60.2c0 1.1-.9 2-2 2z",
    fill: "#f3f5f6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.7 65.9H3.3c-1.7 0-3-1.3-3-3V2.7c0-1.7 1.3-3 3-3h23.4c1.7 0 3 1.3 3 3v60.2c0 1.7-1.4 3-3 3zM3.3 1.7c-.6 0-1 .4-1 1v60.2c0 .6.4 1 1 1h23.4c.6 0 1-.4 1-1V2.7c0-.6-.4-1-1-1H3.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 53.8,
    cy: 35.9,
    r: 18.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.8 55.6c-10.9 0-19.7-8.8-19.7-19.7 0-10.9 8.8-19.7 19.7-19.7 10.9 0 19.7 8.8 19.7 19.7 0 10.9-8.8 19.7-19.7 19.7zm0-37.4c-9.8 0-17.7 7.9-17.7 17.7 0 9.8 7.9 17.7 17.7 17.7 9.8 0 17.7-8 17.7-17.7 0-9.8-7.9-17.7-17.7-17.7z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 53.8,
    cy: 35.9,
    r: 15.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.8 52.5c-9.2 0-16.6-7.4-16.6-16.6 0-9.2 7.4-16.6 16.6-16.6s16.6 7.4 16.6 16.6c0 9.1-7.4 16.6-16.6 16.6zm0-31.2c-8.1 0-14.6 6.5-14.6 14.6s6.5 14.6 14.6 14.6 14.6-6.6 14.6-14.6c0-8.1-6.5-14.6-14.6-14.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.3 20.3h3v4.3h-3zM52.3 47.2h3v4.3h-3zM38.2 34.4h4.3v3h-4.3zM65.2 34.4h4.3v3h-4.3zM53.8 37.4c-.6 0-1.1-.3-1.4-.9l-4.9-11.3c-.3-.8 0-1.6.8-2 .8-.3 1.6 0 2 .8l4.9 11.3c.3.8 0 1.6-.8 2-.2.1-.4.1-.6.1z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.1 42.7c-.3 0-.7-.1-1-.4L52.8 37c-.6-.5-.7-1.5-.2-2.1.5-.6 1.5-.7 2.1-.2l6.2 5.3c.6.5.7 1.5.2 2.1-.2.4-.6.6-1 .6z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4 47.5c-.2 0-.4-.1-.4-.3l-5.5-11.1c-.1-.2 0-.5.2-.7.2-.1.5 0 .7.2l5.5 11.1c.1.2 0 .5-.2.7-.2.1-.3.1-.3.1z",
    fill: "#f1070f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 53.8,
    cy: 35.9,
    r: 2.8,
    fill: "#96a0a8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.8 39.7c-2.1 0-3.8-1.7-3.8-3.8 0-2.1 1.7-3.8 3.8-3.8s3.8 1.7 3.8 3.8c0 2.1-1.7 3.8-3.8 3.8zm0-5.6c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.8-.8 1.8-1.8-.8-1.8-1.8-1.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 14.9,
    cy: 9.7,
    r: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.9 14.9c-2.9 0-5.3-2.4-5.3-5.3s2.4-5.3 5.3-5.3 5.3 2.4 5.3 5.3-2.4 5.3-5.3 5.3zm0-8.5c-1.8 0-3.3 1.5-3.3 3.3s1.5 3.3 3.3 3.3 3.3-1.5 3.3-3.3-1.5-3.3-3.3-3.3z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.8 74.3h-9.3c-.6 0-1-.4-1-1s.4-1 1-1h9.3c.6 0 1 .4 1 1s-.5 1-1 1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingWristWatch);
export default __webpack_public_path__ + "static/media/waiting-wrist-watch.2ba836c4b1ace53c210c5d4a3a082cf7.svg";
export { ForwardRef as ReactComponent };